import { useState, useEffect } from 'react';
import { map } from 'lodash'

import abecedarioVisualDB from '../../../documents/Preescolar/abecesarioVisual.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardGeneral from '../../../components/Cards/CardGeneral/CardGeneral';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './AbecedarioVisual.scss';

export default function AbecedarioVisual() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(abecedarioVisualDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="abecedarioVisual">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="abecedarioVisual__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="abecedarioVisual__titulo">Abecedario Visual</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardGeneral
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}